import { COUNTRY_NAME_BY_CODE } from '@tandemone/types'

/** every country a supplier can onboard from, as facet options. shared by the
 *  directory, the due-diligence queue, and the companies admin filter sheet.
 */
export const COUNTRY_FILTER_OPTIONS = Object.values(COUNTRY_NAME_BY_CODE)
  .sort()
  .map(name => ({ value: name, label: name }))
